import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { useWindowSize } from '@app/hooks';
import { useInventoryHeader } from '@app/pages/Warehouses/Inventory/hooks';

export const InventoryHeader = () => {
  const { goToAddInventory, IsInventoryCreate } = useInventoryHeader();
  const { isMobile } = useWindowSize();

  if (!IsInventoryCreate) {
    return null;
  }

  return (
    <Button
      className={isMobile ? 'full-width' : ''}
      type="primary"
      onClick={goToAddInventory}
      icon={<PlusOutlined />}
    >
      Создать инвентаризацию
    </Button>
  );
};
